import TableHead from "./Table/TableHead";

import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";

import { Table, TBody } from "../components";

import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import DeleteModal from "./Table/DeleteModal";

function FleetHistory() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination,
    genders,
    dobRange,
    setDobRange,
    selectedGenders,
    setSelectedGenders,
    doaRange,
    setDoaRange,
    setOrder,
    clearFilters,
    systemId,
    setSystemId,
    refetchDocs,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
    vehicle,
    setVehicle,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          isFiltered,
          setIsFiltered,
          pagination,
          genders,
          dobRange,
          setDobRange,
          selectedGenders,
          setSelectedGenders,
          doaRange,
          setDoaRange,
          setOrder,
          clearFilters,
          systemId,
          setSystemId,
          refetchDocs,
          showDeleteModal,
          setShowDeleteModal,
          handleDelete,
          vehicle,
          setVehicle,
        }}
      >
        <Table
          label="Fleet Routes"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          isFiltered={isFiltered}
          // handleAdd={() => navigate("add")}
          setIsFiltered={setIsFiltered}
          handleRemoveFilters={clearFilters}
          pagination={pagination}
          url="routes/search"
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => {
              return <TableRow key={doc?.id || i} doc={doc} />;
            })}
          </TBody>
        </Table>
      </TableContext.Provider>
      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          systemId={systemId}
        />
      )}
    </>
  );
}

export default FleetHistory;
